<template>
    <div class="spark-content-podcast-block">
        <div class="podcast-platforms">
            You can listen to our podcasts online via the player below or search for
            <span class="podcast-name">'Talking New Energy'</span>
            and review, rate and subscribe on
            <a href="https://deltaee.podbean.com/" target="_blank" rel="noopener noreferrer">Podbean</a>,
            <a href="https://open.spotify.com/show/2NRYwxIWfCgNikmvuSKrVQ" target="_blank" rel="noopener noreferrer">Spotify</a>
            or
            <a href="https://podcasts.apple.com/gb/podcast/talking-new-energy/id1457559037" target="_blank" rel="noopener noreferrer">Apple Podcasts</a>.
        </div>
        <iframe
            :src="embedUrl"
            loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowfullscreen
            frameborder="0"
            :title="embedTitle"
            :style="{ minHeight: embedMinHeight, borderRadius: '15px' }"
        />
    </div>
</template>

<script setup lang="ts">
defineProps<{
    embedUrl: string;
    embedTitle: string;
    embedMinHeight: string;
}>();
</script>

<style scoped lang="scss">
.spark-content-podcast-block {
    display: flex;
    flex-direction: column;
    gap: var(--largeSpacing);

    iframe {
        width: 100%;
        display: block;
        background: transparent;
    }
}

.podcast-platforms {
    color: var(--neutral700);
    line-height: 1.75;

    a {
        color: var(--accentColour);
        font-weight: var(--semiBoldFontWeight);
    }
}

.podcast-name {
    font-weight: var(--semiBoldFontWeight);
}
</style>
